import { AnnotationPlugin } from '@st/document-viewer-kit'
import { CalculatorTapeAnnotation } from '@st/sdk'
import { CalculatorTapeToolState } from '~/st-doc-viewer/annotations'
import { CalculatorTapeAnnotationElement, CalculatorTapeToolOverlay } from './ui'

export function calculatorTapePlugin(): AnnotationPlugin<
  CalculatorTapeAnnotation,
  CalculatorTapeToolState
> {
  return {
    name: 'calculator_tape',
    initialToolState: {
      name: 'calculator_tape',
      settings: {}
    },
    ToolOverlay: CalculatorTapeToolOverlay,
    Element: CalculatorTapeAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type === 'calculator_tape',
    onAnnotationDeselected: (event) => {
      const draft = event.annotationDraft
      // Empty tapes survive navigation; only the Done button discards them.
      if (!draft || draft.lineItems.length === 0) return null

      // Blank text is saved as an explicit empty string, including when
      // clearing existing text or editing a legacy tape with null fields.
      return {
        type: 'commitAnnotationDraft',
        annotationDraft: {
          ...draft,
          title: savedTapeText(draft.title),
          lineItems: draft.lineItems.map((item) => ({
            ...item,
            description: savedTapeText(item.description)
          }))
        }
      }
    }
  }
}

function savedTapeText(value: string | undefined): string {
  if (!value?.trim()) return ''
  return value
}
